/**
 * Generate a random 6-character join code for households
 * Format: ABC-123 (3 letters, dash, 3 numbers)
 * @returns {string} Join code
 */
export function generateJoinCode(): string {
  const letters = 'ABCDEFGHJKLMNPQRSTUVWXYZ'; // Removed I and O to avoid confusion
  const numbers = '0123456789';

  let code = '';

  // Generate 3 random letters
  for (let i = 0; i < 3; i++) {
    code += letters.charAt(Math.floor(Math.random() * letters.length));
  }

  code += '-';

  // Generate 3 random numbers
  for (let i = 0; i < 3; i++) {
    code += numbers.charAt(Math.floor(Math.random() * numbers.length));
  }

  return code;
}

/**
 * Validate join code format
 * @param {string} code - Code to validate
 * @returns {boolean} True if valid format
 */
export function isValidJoinCode(code: string): boolean {
  const regex = /^[A-Z]{3}-[0-9]{3}$/;
  return regex.test(code);
}

/**
 * Format user input into join code format
 * @param {string} input - Raw user input
 * @returns {string} Formatted code (uppercase, with dash)
 */
export function formatJoinCode(input: string): string {
  // Remove all non-alphanumeric characters
  const cleaned = input.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  if (cleaned.length <= 3) {
    return cleaned;
  }

  // Add dash after 3 characters
  return cleaned.slice(0, 3) + '-' + cleaned.slice(3, 6);
}
